import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button } from "@material-ui/core";


export default function SearchModule(props) {
  //const [value, setValue] = useState([]);
  const [country, setCountry] = useState([]);
  const [specialty, setSpecialty] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [provider, setProvider] = useState("");


  return (
    <div className="shadow p-3 mb-5 col-sm-12 search-panel">
      <div className="d-flex justify-content-around ">
        {/* Search by Country */}
        <Autocomplete
          id="search-by-country"
          onChange={(e, newValue) => setCountry(newValue)}
          options={countries}
          getOptionLabel={(option) => option.name}
          style={{ width: 300 }}
          className="mx-2"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Filter by Country"
              variant="outlined"
              className="bg-white"
            />
          )}
        />
        {/* Search By Specialty */}
        <Autocomplete
          id="search-by-specialty"
          onChange={(e, newValue) => setSpecialty(newValue)}
          options={props.specialties}
          getOptionLabel={(option) => option.speciality_name}
          className="mx-2"
          //getOptionDisabled={(option) => option === timeSlots[0] || option === timeSlots[2]}
          style={{ width: 300 }}
          // disabled
          renderInput={(params) => (
            <TextField
              {...params}
              label="Filter by Specialty"
              variant="outlined"
              className="bg-white"
              // disabled
            />
          )}
        />

        {/* Search by Providers name */}
        <Autocomplete
          id="search-by-name"
          onChange={(e, newValue) => setProvider(newValue)}
          options={props.providers}
          getOptionLabel={(option) => option.firstName + " " + option.lastname}
          style={{ width: 300 }}
          className="mx-2"
          // disabled
          renderInput={(params) => (
            <TextField
              {...params}
              label="Filter by Provider's name"
              variant="outlined"
              className="bg-white"
            />
          )}
        />
      </div>
      <div className="d-flex justify-content-end m-3">
        <Button
          onClick={() => props.handleSearch(country, specialty, provider)}
          variant="contained"
          color="primary"
        >
          Search
        </Button>
      </div>
    </div>
  );
}

const countries = [
  { name: "United States", code: "USA" },
  { name: "Costa Rica", code: "CRC" },
  { name: "Bahamas", code: "BHA" },
  { name: "Jamaica", code: "JAM" },
  { name: "Nicaragua", code: "NIC" },
];
